module.exports = __webpack_public_path__ + "img/tips_path.c116363f.png";